import { render } from "./MobSupport.vue?vue&type=template&id=5c882dcb&scoped=true"
import script from "./MobSupport.vue?vue&type=script&lang=js"
export * from "./MobSupport.vue?vue&type=script&lang=js"

import "./MobSupport.vue?vue&type=style&index=0&id=5c882dcb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c882dcb"]])

export default __exports__